import { getPancakeBunniesAddress, getNutsAddress } from 'utils/addressHelpers'

export const nftsBaseUrl = '/nfts'
export const pancakeBunniesAddress = getPancakeBunniesAddress()
export const nutsAddress = getNutsAddress()
